import { useLocation } from 'react-router-dom';

export default function useInsightsRoutes() {
  const location = useLocation();

  return location.pathname.includes('insights');
}
